<template>
  <b-card title="Kiracı">
    <b-list-group>
      <b-list-group-item v-if="dataItem.tenants.tenant_code">
        <div class="font-weight-bold text-primary">
          Kiracı Kodu:
        </div>
        <div>
          {{ dataItem.tenants.tenant_code }}
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.tenants.title">
        <div class="font-weight-bold text-primary">
          Kiracı Adı:
        </div>
        <div>
          {{ dataItem.tenants.title }}
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.tenants.phone">
        <div class="font-weight-bold text-primary">
          Telefon:
        </div>
        <div>
          {{ dataItem.tenants.phone }}
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.tenants.notes">
        <div class="font-weight-bold text-primary">
          Not:
        </div>
        <div>
          {{ dataItem.tenants.notes }}
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.tenants.sdate">
        <div class="font-weight-bold text-primary">
          Başlangıç Tarihi:
        </div>
        <div>
          {{ moment(dataItem.tenants.sdate).format('DD.MM.YYYY') }}
        </div>
        <div class="font-weight-bold text-primary border-top pt-1 mt-1">
          Sözleşme Yenileme Tarihi:
        </div>
        <div>
          {{ moment(dataItem.tenants.sdate).add(1, 'year').format('DD.MM.YYYY') }}
          <div
            v-if="daysRemaining > 90"
            class="text-muted font-small-3"
          >
            Sözleşme bitişine {{ daysRemaining }} gün kaldı.
          </div>
          <div
            v-else-if="daysRemaining <= 90 && daysRemaining > 60"
            class="text-warning font-small-3"
          >
            Sözleşme bitişine {{ daysRemaining }} gün kaldı.
          </div>
          <div
            v-else-if="daysRemaining <= 30 && daysRemaining >= 0"
            class="text-danger font-small-3"
          >
            Sözleşme bitişine {{ daysRemaining }} gün kaldı.
          </div>
          <div
            v-else
            class="text-danger font-small-3"
          >
            Sözleşme süresi doldu.
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.tenants.amount">
        <div class="font-weight-bold text-primary">
          Kira Bedeli:
        </div>
        <div>
          {{ dataItem.tenants.amount | toCurrency }} ₺
        </div>
      </b-list-group-item>
      <b-list-group-item class="d-flex justify-content-between">
        <b-button
          variant="light"
          size="sm"
          pill
          @click="openTenantModal('infoUpdate')"
        >
          <FeatherIcon icon="EditIcon" />
          Bilgi Güncelle
        </b-button>
        <div>
          <b-button
            variant="success"
            size="sm"
            class="mr-1"
            pill
            @click="openTenantModal('renewal')"
          >
            <FeatherIcon icon="RefreshCwIcon" />
            Sözleşme Yenile</b-button>
          <b-button
            variant="danger"
            size="sm"
            class="mr-1"
            pill
            @click="openTenantModal('ended')"
          >
            <FeatherIcon icon="XCircleIcon" />
            Sözleşme Sonlandır
          </b-button>
        </div>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup, BListGroupItem, BButton,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'TenantViewCard',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    BButton,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    tenantModal() {
      return this.$store.getters['estates/tenantModal']
    },
    daysRemaining() {
      if (this.dataItem.tenants.sdate) {
        const endDate = moment(this.dataItem.tenants.sdate).add(1, 'year')
        const today = moment()
        return endDate.diff(today, 'days')
      }
      return 0
    },
  },
  methods: {
    openTenantModal(type) {
      this.tenantModal.status = true
      this.tenantModal.type = type
      if (type === 'renewal') {
        this.dataItem.tenants = {
          ...this.dataItem.tenants,
          renewal_sdate: moment().format('YYYY-MM-DD'),
          renewal_amount: this.dataItem.tenants.amount,
        }
      } else {
        const { renewal_sdate, renewal_amount, ...rest } = this.dataItem.tenants
        this.dataItem.tenants = rest
      }
    },
  },
}
</script>
